module.exports = __webpack_public_path__ + "static/media/Flip-Coin-2.499c9881.png";